"use client";

import React from "react";

export const UnsubscribeHeader: React.FC = () => {
  return (
    <div className="mb-5 flex flex-col items-center gap-[6px] md:mb-6">
      <div className="text-[42px]">😔</div>
      <h1 className="text-center text-[16px] font-bold leading-[24px] text-[#17142A]">
        We are sorry we did not meet your expectations.
      </h1>
    </div>
  );
};
